module.exports = __webpack_public_path__ + "102040461d0f54e2c5351d6667d0176b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-25.png
// module id = 2466
// module chunks = 0